import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import SweetAlert from 'react-bootstrap-sweetalert';
import moment from 'moment';
import 'moment/locale/pt-br';
import DatePicker from 'react-datepicker';
import ReactCrop from 'react-image-crop';
import api from '../../services/api';

import Input from '../../components/Input';
import TextArea from '../../components/TextArea';
import Select from '../../components/Select';
import Loading from '../../components/Loading';
import { Container, ButtonPanel } from './styles';
import 'react-image-crop/dist/ReactCrop.css';

export default class EditEvent extends Component {
  state = {
    address: '',
    alert: {},
    benefits: '',
    crop: {
      aspect: 1.5,
      width: 360,
      x: 0,
      y: 0,
    },
    currentCover: null,
    end_at: null,
    extra: '',
    loading: true,
    min_followers: '',
    name: '',
    place: '',
    rules: '',
    segment: null,
    segments: [],
    showAlert: false,
    slots: '',
    start_at: null,
    whatsapp_link: '',
  };

  static propTypes = {
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
    match: PropTypes.shape().isRequired,
  };

  componentDidMount() {
    this.loadEvent();
    this.loadSegments();
  }

  onSelectFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener('load', () => this.setState({ src: reader.result }));
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  onImageLoaded = (image, pixelCrop) => {
    this.imageRef = image;

    const { crop } = this.state;

    if (crop.aspect && crop.height && crop.width) {
      this.setState({
        crop: { ...crop, height: null },
      });
    } else {
      this.makeClientCrop(crop, pixelCrop);
    }

    this.setState(
      {
        alert: {
          title: 'Posicione e corte a imagem',
          type: 'info',
          messages: ['Clique em cima da imagem quando estiver na posição correta.'],
          onConfirm: () => this.closeAlert(),
        },
      },
      () => {
        this.openAlert();
      },
    );
  };

  onCropComplete = (crop, pixelCrop) => {
    this.makeClientCrop(crop, pixelCrop);
  };

  onCropChange = (crop) => {
    this.setState({ crop });
  };

  getCroppedImg(image, pixelCrop) {
    const canvas = document.createElement('canvas');
    canvas.width = pixelCrop.width;
    canvas.height = pixelCrop.height;
    const ctx = canvas.getContext('2d');

    ctx.drawImage(
      image,
      pixelCrop.x,
      pixelCrop.y,
      pixelCrop.width,
      pixelCrop.height,
      0,
      0,
      pixelCrop.width,
      pixelCrop.height,
    );

    return new Promise((resolve) => {
      canvas.toBlob((blob) => {
        window.URL.revokeObjectURL(this.fileUrl);
        this.fileUrl = window.URL.createObjectURL(blob);
        resolve(this.fileUrl);
        this.setState({ croppedImage: this.blobToFile(blob, 'cover.jpg') });
      }, 'image/jpeg');
    });
  }

  loadEvent = async () => {
    try {
      const { data } = await api.get(`events/${this.props.match.params.id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
        },
      });

      data.event.start_at = moment(data.event.start_at);
      data.event.end_at = moment(data.event.end_at);

      const {
        address,
        benefits,
        cover,
        end_at,
        extra,
        min_followers,
        name,
        place,
        rules,
        segment,
        slots,
        start_at,
        whatsapp_link,
      } = data.event;

      this.setState({
        address,
        benefits,
        currentCover: cover,
        end_at,
        extra,
        min_followers,
        name,
        place,
        rules,
        slots,
        start_at,
        whatsapp_link,
      });

      if (segment) {
        this.setState({ segment: segment.id });
      }
    } catch (err) {
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages: ['Não foi possível carregar o evento. Por favor, atualize a página.'],
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  loadSegments = async () => {
    try {
      const { data } = await api.get('segments', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
        },
      });

      this.setState({
        segments: data.segments,
      });

      this.setState({ loading: false });
    } catch (err) {
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages: ['Não foi possível carregar os segmentos. Por favor, atualize a página.'],
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  handleSubmit = async (e) => {
    const {
      address,
      croppedImage,
      extra,
      min_followers,
      place,
      segment,
      whatsapp_link,
    } = this.state;

    e.preventDefault();

    this.setState({ loading: true });

    try {
      const formData = new FormData();
      if (croppedImage) {
        formData.append('cover', croppedImage);
      }
      formData.append('address', address);
      formData.append('extra', extra);
      formData.append('min_followers', min_followers);
      formData.append('place', place);
      formData.append('segment_id', segment);
      formData.append('whatsapp_link', whatsapp_link);

      const res = await api.put(`events/${this.props.match.params.id}`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
        },
      });
      window.location.href = `/panel/events/${res.data.id}`;
    } catch (err) {
      this.setState({ loading: false });
      const messages = err.response && err.response.data && err.response.data.errors
        ? err.response.data.errors
        : ['Não foi possível completar a requisição. Por favor, atualize a página.'];
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages,
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleChangeSegment = (e) => {
    this.setState({
      segment: e.target.value,
    });
  };

  handleChangeStartDate = (date) => {
    const { start_at, end_at } = this.state;

    this.setState(
      {
        start_at: date,
      },
      () => {
        if (start_at >= end_at) {
          this.setState({
            end_at: null,
          });
        }
      },
    );
  };

  handleChangeEndDate = (date) => {
    this.setState({
      end_at: date,
    });
  };

  openAlert = () => {
    this.setState({
      showAlert: true,
    });
  };

  closeAlert = () => {
    this.setState({
      showAlert: false,
    });
  };

  blobToFile = (theBlob, fileName) => {
    const blob = theBlob;
    blob.lastModifiedDate = new Date();
    blob.name = fileName;
    return theBlob;
  }

  async makeClientCrop(crop, pixelCrop) {
    if (this.imageRef && crop.width && crop.height) {
      const croppedImageUrl = await this.getCroppedImg(this.imageRef, pixelCrop, 'newFile.jpeg');
      this.setState({ croppedImageUrl });
    }
  }

  render() {
    const {
      address,
      alert: {
        cancelBtnText,
        cancelBtnBsStyle,
        confirmBtnText,
        confirmBtnBsStyle,
        messages,
        onConfirm,
        showCancel,
        title,
        type,
      },
      benefits,
      crop,
      croppedImageUrl,
      currentCover,
      end_at,
      extra,
      loading,
      min_followers,
      name,
      place,
      rules,
      segment,
      segments,
      showAlert,
      slots,
      src,
      start_at,
      whatsapp_link,
    } = this.state;

    return (
      <Fragment>
        {loading && <Loading />}
        <Container>
          <h1 className="page-title">Editar evento</h1>
          <div className="box">
            <form onSubmit={this.handleSubmit}>
              <div className="row">
                <div className="col-sm-6">
                  <Input
                    name="name"
                    value={name}
                    onChange={this.handleChange}
                    placeholder="Nome"
                    disabled
                  />
                  <Input
                    name="place"
                    value={place}
                    onChange={this.handleChange}
                    placeholder="Nome do local"
                  />
                  <Input
                    name="address"
                    value={address}
                    onChange={this.handleChange}
                    placeholder="Endereço"
                  />
                  <div className="row">
                    <div className="col-lg-6">
                      <DatePicker
                        selected={start_at}
                        dateFormat="DD/MM/YYYY, HH:mm[h]"
                        timeFormat="HH:mm"
                        locale="pt-br"
                        disabled
                      />
                    </div>
                    <div className="col-lg-6">
                      <DatePicker
                        selected={end_at}
                        dateFormat="DD/MM/YYYY, HH:mm[h]"
                        timeFormat="HH:mm"
                        locale="pt-br"
                        disabled
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-6">
                      <Input
                        name="min_followers"
                        value={min_followers}
                        onChange={this.handleChange}
                        type="number"
                        placeholder="Mínimo de seguidores"
                      />
                    </div>
                    <div className="col-lg-6">
                      <Input
                        name="slots"
                        value={slots}
                        onChange={this.handleChange}
                        type="number"
                        placeholder="Número de vagas"
                        disabled
                      />
                    </div>
                  </div>
                  <Input
                    name="whatsapp_link"
                    value={whatsapp_link}
                    onChange={this.handleChange}
                    placeholder="Link do grupo no WhatsApp"
                  />
                  <Select
                    value={segment}
                    name="segment"
                    onChange={this.handleChangeSegment}
                    description="Segmento"
                    options={
                      segments.map(s => ({ value: s.id, text: s.name }))
                    }
                  />
                </div>
                <div className="col-sm-6">
                  <TextArea
                    name="benefits"
                    value={benefits}
                    onChange={this.handleChange}
                    placeholder="Benefícios"
                    disabled
                  />
                  <TextArea
                    name="extra"
                    value={extra}
                    onChange={this.handleChange}
                    placeholder="Mais informações"
                  />
                  <TextArea
                    name="rules"
                    value={rules}
                    onChange={this.handleChange}
                    placeholder="Regras do evento"
                    disabled
                  />
                </div>
                <div className="col-12">
                  <div className="upload-group">
                    <span className="label">Alterar imagem de capa:</span>
                    <span className="desc">Tamanho recomendado: 870x560px (PNG ou JPG)</span>
                    <span className="desc">Peso máximo: 10 MB</span>
                    <input type="file" accept="image/*" onChange={this.onSelectFile} />
                    <div className="row">
                      <div className="col-sm-6 d-none d-sm-block">
                        {src && (
                          <Fragment>
                            <span className="secondary-label">Posicione ou recorte a imagem de capa:</span>
                            <span className="desc">Clique em cima da imagem quando a posição estiver perfeita</span>
                            <ReactCrop
                              src={src}
                              crop={crop}
                              onImageLoaded={this.onImageLoaded}
                              onComplete={this.onCropComplete}
                              onChange={this.onCropChange}
                            />
                          </Fragment>
                        )}
                        {!src && currentCover && (
                          <Fragment>
                            <img className="ReactCrop__current-cover" src={currentCover} alt="Imagem de capa" />
                          </Fragment>
                        )}
                      </div>
                      <div className="col-6">
                        {croppedImageUrl && (
                          <Fragment>
                            <span className="secondary-label">Imagem cortada:</span>
                            <span className="desc">A capa aparecerá assim para os usuários</span>
                            <img alt="Crop" className="ReactCrop__result" src={croppedImageUrl} />
                          </Fragment>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <ButtonPanel>
                    <Link to="/panel/" className="btn btn-light">
                      Cancelar
                    </Link>
                    <input type="submit" className="btn btn-success" value="Salvar" />
                  </ButtonPanel>
                </div>
              </div>
            </form>
          </div>
          {showAlert && (
            <SweetAlert
              type={type}
              confirmBtnText={confirmBtnText}
              confirmBtnBsStyle={confirmBtnBsStyle}
              showCancel={showCancel}
              cancelBtnText={cancelBtnText}
              cancelBtnBsStyle={cancelBtnBsStyle}
              title={title}
              onConfirm={onConfirm}
              onCancel={this.closeAlert}
            >
              <ul>
                {messages.map(msg => (
                  <li key={msg}>{msg}</li>
                ))}
              </ul>
            </SweetAlert>
          )}
        </Container>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/EditEvent/index.js